import React from "react"
import { useTranslation } from "react-i18next"

import { Checkbox } from "components"
import classes from "./OfsIsViewed.module.scss"

const OfsIsViewed = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const handleIsViewed = (checked) => {
    setForm(prev => ({
      ...prev, isViewed: checked
    }))
  }

  return (
    <div className={classes["checkbox-container"]}>
      <div className={classes["checkbox"]}>
        {t("سفارشات_جدید")}
      </div>

      <Checkbox
        checked={!form.isViewed}
        onChange={checked => handleIsViewed(!checked)}
      />
    </div>
  )
}

export default OfsIsViewed